import React from "react";
import Svg, { Path, SvgProps } from "react-native-svg";

const RoundEmptyTick = (props: SvgProps) => {
  return (
    <Svg width="21" height="20" fill="none">
      <Path
        fill="#63C005"
        d="M10.5 0a10 10 0 1 0 10 10 10.011 10.011 0 0 0-10-10Zm0 18.182A8.181 8.181 0 1 1 18.682 10a8.193 8.193 0 0 1-8.182 8.182Z"
      />
      <Path
        fill="#63C005"
        stroke="#63C005"
        strokeWidth=".5"
        d="M14.196 6.632a.98.98 0 0 1 1.232 1.524l-6.45 5.21a.975.975 0 0 1-.746.209h-.004a.987.987 0 0 1-.664-.406L5.43 10.15A.978.978 0 0 1 7.028 9.02l1.53 2.167 5.637-4.554.022.025-.02-.026Z"
      />
    </Svg>
  );
};

export default RoundEmptyTick;
